export const bytesToMb = (bytes: number) => bytes / (1024 * 1024);

/** Human-readable byte size (e.g. `12 MB`); empty string for folders/unknown. */
export function formatFileSize(bytes: number | null | undefined): string {
  const value = Number(bytes);
  if (!bytes || !Number.isFinite(value) || value <= 0) return '';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const step = 1024;
  const unitIndex = Math.min(Math.floor(Math.log(value) / Math.log(step)), units.length - 1);
  const size = value / Math.pow(step, unitIndex);
  return `${parseFloat(size.toFixed(1))} ${units[unitIndex]}`;
}
